import { render } from "./FlagMatchGame.vue?vue&type=template&id=d81b29a8&scoped=true"
import script from "./FlagMatchGame.vue?vue&type=script&lang=js"
export * from "./FlagMatchGame.vue?vue&type=script&lang=js"

import "./FlagMatchGame.vue?vue&type=style&index=0&id=d81b29a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d81b29a8"]])

export default __exports__